function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1916(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.51,
    height: 15.97,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.99625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 7.985
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.97,
    width: 26.51,
    height: 16.43,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.347142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 24.185000000000002
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.4,
    width: 26.51,
    height: 19.09,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4684615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 41.945
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.49,
    width: 26.51,
    height: 20.02,
    style: {
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3366666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 61.5
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 71.5,
    width: 26.51,
    height: 26.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 84.92
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 98.35,
    width: 26.51,
    height: 28.23,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 112.46499999999999
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126.58,
    width: 26.51,
    height: 29.97,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.418333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 141.565
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156.55,
    width: 26.51,
    height: 29.97,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.418333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 171.53500000000003
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 186.51,
    width: 26.51,
    height: 31.93,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7871428571428574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 202.475
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 218.45,
    width: 26.51,
    height: 31.93,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6510000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 234.415
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 250.38,
    width: 26.51,
    height: 32.74,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7871428571428574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 266.75
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.12,
    width: 26.51,
    height: 33.55,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 299.895
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 316.68,
    width: 26.51,
    height: 37.14,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3020000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 335.25
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 353.82,
    width: 26.51,
    height: 37.37,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.836666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 372.505
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 391.19,
    width: 26.51,
    height: 38.53,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3020000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 410.455
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 429.72,
    width: 26.51,
    height: 42.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6510000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 451.06500000000005
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 472.41,
    width: 26.51,
    height: 43.27,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7871428571428574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 494.045
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 515.69,
    width: 26.51,
    height: 44.2,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 537.7900000000001
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 559.88,
    width: 26.51,
    height: 45.59,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7871428571428574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 582.675
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 605.47,
    width: 26.51,
    height: 46.28,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.418333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 628.61
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 651.75,
    width: 26.51,
    height: 48.25,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.255,
    y: 675.875
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 0,
    width: 33.73,
    height: 38.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.375,
    y: 19.055
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.24,
    y: 0,
    width: 33.73,
    height: 38.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7477777777777774
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 77.105,
    y: 19.055
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 0,
    width: 34.29,
    height: 38.11,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.115,
    y: 19.055
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.26,
    y: 0,
    width: 34.45,
    height: 38.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.741666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.48499999999999,
    y: 19.055
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.71,
    y: 0,
    width: 34.53,
    height: 38.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.932857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.97500000000002,
    y: 19.055
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.24,
    y: 0,
    width: 34.69,
    height: 38.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.938
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.585,
    y: 19.055
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.93,
    y: 0,
    width: 35.01,
    height: 38.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.835
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.435,
    y: 19.055
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.95,
    y: 0,
    width: 35.66,
    height: 38.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.094285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.78,
    y: 19.055
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.6,
    y: 0,
    width: 36.62,
    height: 38.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.324
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.91,
    y: 19.055
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.23,
    y: 0,
    width: 37.67,
    height: 38.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.278333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.065,
    y: 19.055
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.9,
    y: 0,
    width: 37.83,
    height: 38.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.404285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.815,
    y: 19.055
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.73,
    y: 0,
    width: 37.83,
    height: 38.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.64500000000004,
    y: 19.055
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.56,
    y: 0,
    width: 39.12,
    height: 38.11,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.12,
    y: 19.055
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.68,
    y: 0,
    width: 41.13,
    height: 38.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.444285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.245,
    y: 19.055
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.82,
    y: 0,
    width: 41.21,
    height: 38.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.4250000000001,
    y: 19.055
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.03,
    y: 0,
    width: 41.37,
    height: 38.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.7149999999999,
    y: 19.055
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 615.4,
    y: 0,
    width: 42.02,
    height: 38.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.234444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.41,
    y: 19.055
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 657.42,
    y: 0,
    width: 42.58,
    height: 38.11,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 678.7099999999999,
    y: 19.055
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 38.11,
    width: 42.13,
    height: 39.47,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.578333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 57.845
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 77.57,
    width: 42.13,
    height: 39.61,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.601666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 97.375
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 117.19,
    width: 42.13,
    height: 39.68,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 137.03
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 156.87,
    width: 42.13,
    height: 40.41,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.772857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 177.075
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 197.28,
    width: 42.13,
    height: 40.56,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.760000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 217.56
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 237.84,
    width: 42.13,
    height: 40.63,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.126000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 258.15500000000003
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 278.47,
    width: 42.13,
    height: 40.63,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.126000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 298.785
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 319.1,
    width: 42.13,
    height: 40.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.126000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 339.415
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 359.73,
    width: 42.13,
    height: 41.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 380.3
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 400.87,
    width: 42.13,
    height: 41.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.971428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 421.77
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 442.67,
    width: 42.13,
    height: 41.87,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.23375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 463.605
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 484.54,
    width: 42.13,
    height: 41.87,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.978333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 505.475
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 526.41,
    width: 42.13,
    height: 42.89,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.018571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 547.855
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 569.3,
    width: 42.13,
    height: 43.33,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.018571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 590.9649999999999
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 612.62,
    width: 42.13,
    height: 43.62,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.021666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 634.43
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.51,
    y: 656.24,
    width: 42.13,
    height: 43.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.26625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.575,
    y: 678.12
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 38.11,
    width: 40.74,
    height: 45.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.01,
    y: 60.849999999999994
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.38,
    y: 38.11,
    width: 41.42,
    height: 45.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.917142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.09,
    y: 60.849999999999994
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.8,
    y: 38.11,
    width: 41.75,
    height: 45.48,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.21875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.675,
    y: 60.849999999999994
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.55,
    y: 38.11,
    width: 43.91,
    height: 45.48,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.48875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.505,
    y: 60.849999999999994
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.46,
    y: 38.11,
    width: 44.52,
    height: 45.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.420000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.72,
    y: 60.849999999999994
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.98,
    y: 38.11,
    width: 44.72,
    height: 45.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.34000000000003,
    y: 60.849999999999994
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.7,
    y: 38.11,
    width: 45.46,
    height: 45.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.43,
    y: 60.849999999999994
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.17,
    y: 38.11,
    width: 45.94,
    height: 45.48,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.096
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.14,
    y: 60.849999999999994
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.1,
    y: 38.11,
    width: 45.94,
    height: 45.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.497142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.07000000000005,
    y: 60.849999999999994
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.04,
    y: 38.11,
    width: 46.27,
    height: 45.48,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.497142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.175,
    y: 60.849999999999994
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.31,
    y: 38.11,
    width: 46.75,
    height: 45.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.685,
    y: 60.849999999999994
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.06,
    y: 38.11,
    width: 47.62,
    height: 45.48,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.096
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.8699999999999,
    y: 60.849999999999994
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.68,
    y: 38.11,
    width: 47.96,
    height: 45.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.66,
    y: 60.849999999999994
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.64,
    y: 38.11,
    width: 48.36,
    height: 45.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.548
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.8199999999999,
    y: 60.849999999999994
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 83.58,
    width: 50.34,
    height: 43.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.281666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 105.425
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 127.27,
    width: 50.34,
    height: 44.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.354285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 149.51
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 171.76,
    width: 50.34,
    height: 45.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 194.36499999999998
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 216.97,
    width: 50.34,
    height: 46.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.607142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 240.095
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 263.22,
    width: 50.34,
    height: 46.31,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.718333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 286.375
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 309.53,
    width: 50.34,
    height: 46.8,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 332.92999999999995
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 356.33,
    width: 50.34,
    height: 46.86,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 379.76
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 403.19,
    width: 50.34,
    height: 48.08,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 427.23
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 451.26,
    width: 50.34,
    height: 48.5,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.388888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 475.51
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 499.77,
    width: 50.34,
    height: 48.63,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 524.085
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 548.39,
    width: 50.34,
    height: 50.15,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.26875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 573.465
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 598.54,
    width: 50.34,
    height: 50.39,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.191428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 623.735
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.64,
    y: 648.94,
    width: 50.34,
    height: 51.06,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.81,
    y: 674.47
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 83.58,
    width: 50.81,
    height: 51.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.385,
    y: 109.085
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.79,
    y: 83.58,
    width: 50.81,
    height: 51.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.195,
    y: 109.085
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.61,
    y: 83.58,
    width: 51.35,
    height: 51.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.501666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.28500000000003,
    y: 109.085
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.96,
    y: 83.58,
    width: 52.08,
    height: 51.01,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2871428571428565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298,
    y: 109.085
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.04,
    y: 83.58,
    width: 52.32,
    height: 51.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2871428571428565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.20000000000005,
    y: 109.085
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.36,
    y: 83.58,
    width: 53.04,
    height: 51.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.501666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.88,
    y: 109.085
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.39,
    y: 83.58,
    width: 53.22,
    height: 51.01,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2871428571428565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456,
    y: 109.085
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.61,
    y: 83.58,
    width: 53.34,
    height: 51.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.202
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.28000000000003,
    y: 109.085
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.95,
    y: 83.58,
    width: 53.52,
    height: 51.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.667777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.71,
    y: 109.085
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.47,
    y: 83.58,
    width: 54.18,
    height: 51.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.202
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.5600000000001,
    y: 109.085
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.65,
    y: 83.58,
    width: 56.35,
    height: 51.01,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.7525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.8249999999999,
    y: 109.085
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 134.59,
    width: 56.57,
    height: 52.16,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.693333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 160.67000000000002
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 186.75,
    width: 56.57,
    height: 54.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.6775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 214.105
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 241.46,
    width: 56.57,
    height: 54.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.964
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 268.87
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 296.28,
    width: 56.57,
    height: 55.74,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 324.15
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 352.02,
    width: 56.57,
    height: 56.12,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 380.08
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 408.13,
    width: 56.57,
    height: 57.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.314
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 436.73
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 465.34,
    width: 56.57,
    height: 57.36,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.07125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 494.02
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 522.7,
    width: 56.57,
    height: 58.77,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.428333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 552.085
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 581.48,
    width: 56.57,
    height: 59.05,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.657
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 611.005
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.98,
    y: 640.52,
    width: 56.57,
    height: 59.48,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.428333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.26500000000001,
    y: 670.26
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 134.59,
    width: 53.94,
    height: 64.15,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.394
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.52,
    y: 166.66500000000002
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.49,
    y: 134.59,
    width: 54.65,
    height: 64.15,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.108333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.815,
    y: 166.66500000000002
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.14,
    y: 134.59,
    width: 56.42,
    height: 64.15,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.403333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.34999999999997,
    y: 166.66500000000002
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.57,
    y: 134.59,
    width: 58.96,
    height: 64.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.792
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.05,
    y: 166.66500000000002
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.52,
    y: 134.59,
    width: 59.72,
    height: 64.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.38,
    y: 166.66500000000002
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.25,
    y: 134.59,
    width: 59.77,
    height: 64.15,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.977
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.135,
    y: 166.66500000000002
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.02,
    y: 134.59,
    width: 60.15,
    height: 64.15,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.095,
    y: 166.66500000000002
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.17,
    y: 134.59,
    width: 60.3,
    height: 64.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.614285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.3199999999999,
    y: 166.66500000000002
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.46,
    y: 134.59,
    width: 60.54,
    height: 64.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.726666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.73,
    y: 166.66500000000002
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 198.75,
    width: 68.83,
    height: 57.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.581666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 227.495
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 256.24,
    width: 68.83,
    height: 57.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.264285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 285.165
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 314.09,
    width: 68.83,
    height: 60.52,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 344.34999999999997
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 374.61,
    width: 68.83,
    height: 64.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.174285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 406.72
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 438.83,
    width: 68.83,
    height: 64.27,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.711666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 470.965
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 503.1,
    width: 68.83,
    height: 65.2,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 535.7
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 568.3,
    width: 68.83,
    height: 65.78,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.397142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 601.1899999999999
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.55,
    y: 634.08,
    width: 68.83,
    height: 65.92,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.986666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.965,
    y: 667.0400000000001
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.38,
    y: 198.75,
    width: 63.47,
    height: 71.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.052222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.115,
    y: 234.66
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.85,
    y: 198.75,
    width: 64.28,
    height: 71.82,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.99,
    y: 234.66
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.14,
    y: 198.75,
    width: 64.62,
    height: 71.82,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.770000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.45,
    y: 234.66
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 198.75,
    width: 65.18,
    height: 71.82,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.311428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.35,
    y: 234.66
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.94,
    y: 198.75,
    width: 65.31,
    height: 71.82,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.595,
    y: 234.66
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.25,
    y: 198.75,
    width: 66.12,
    height: 71.82,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.445714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.31,
    y: 234.66
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.37,
    y: 198.75,
    width: 66.63,
    height: 71.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.104999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.685,
    y: 234.66
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.38,
    y: 270.56,
    width: 73.48,
    height: 66.75,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.12,
    y: 303.935
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.38,
    y: 337.31,
    width: 73.48,
    height: 67.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.39125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.12,
    y: 370.875
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.38,
    y: 404.44,
    width: 73.48,
    height: 72.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.12,
    y: 440.82
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.38,
    y: 477.2,
    width: 73.48,
    height: 73.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.12,
    y: 513.79
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.38,
    y: 550.38,
    width: 73.48,
    height: 74.72,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.12,
    y: 587.74
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.38,
    y: 625.11,
    width: 73.48,
    height: 74.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.497142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.12,
    y: 662.5550000000001
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 270.56,
    width: 74.16,
    height: 75.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.94,
    y: 308.12
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.02,
    y: 270.56,
    width: 74.28,
    height: 75.12,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.15999999999997,
    y: 308.12
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.3,
    y: 270.56,
    width: 76.97,
    height: 75.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.785,
    y: 308.12
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.27,
    y: 270.56,
    width: 77.55,
    height: 75.12,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.520000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.045,
    y: 308.12
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.82,
    y: 270.56,
    width: 79.18,
    height: 75.12,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.520000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.4100000000001,
    y: 308.12
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 345.68,
    width: 89.58,
    height: 68.04,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.65000000000003,
    y: 379.7
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 413.72,
    width: 89.58,
    height: 69.1,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.87142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.65000000000003,
    y: 448.27000000000004
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 482.83,
    width: 89.58,
    height: 69.17,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.64625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.65000000000003,
    y: 517.415
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 552,
    width: 89.58,
    height: 73.69,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.527142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.65000000000003,
    y: 588.845
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 625.69,
    width: 89.58,
    height: 74.31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.65000000000003,
    y: 662.845
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.44,
    y: 345.68,
    width: 70.56,
    height: 94.9,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.72,
    y: 393.13
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 345.68,
    width: 72.4,
    height: 94.9,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.066666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.2,
    y: 393.13
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.41,
    y: 345.68,
    width: 74.57,
    height: 94.9,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.6425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.6949999999999,
    y: 393.13
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.98,
    y: 345.68,
    width: 75.02,
    height: 94.9,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.49,
    y: 393.13
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.44,
    y: 440.58,
    width: 102.46,
    height: 77.03,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.406
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.67,
    y: 479.09499999999997
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.44,
    y: 517.61,
    width: 102.46,
    height: 78.5,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.67,
    y: 556.86
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.44,
    y: 596.11,
    width: 102.46,
    height: 103.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.8075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.67,
    y: 648.0550000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.9,
    y: 440.58,
    width: 190.1,
    height: 77.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.021428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.9499999999999,
    y: 479.155
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.9,
    y: 517.73,
    width: 190.1,
    height: 182.27,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.378333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.9499999999999,
    y: 608.865
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1916);
export default __webpack_public_path__ + "static/media/1916.84ea41eec725b27f1157789468fe2638.svg";
export { ForwardRef as ReactComponent };